import { SupplementaryField } from '../../../../api/configurations/supplementary/types';

export enum FieldTypes {
  short = 'short',
  long = 'long',
  date = 'date'
}
export type FormValues = {
  [key: string]: SupplementaryField | string[];
};

export type Fields = {
  [key: string]: SupplementaryField;
};
